import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const SearchDataPointSchema = withDefaults({
  // No 'search-' prefix -- see search-index-definition.schema.ts's identical comment. Matches
  // Api::V2::Admin::DataPointResource's own bare wire type ('data-points', normalized singular).
  type: 'data-point',
  fields: [
    {
      kind: 'attribute',
      name: 'outputField',
    },
    {
      kind: 'attribute',
      name: 'sourceKind',
    },
    {
      kind: 'attribute',
      name: 'sourceRef',
    },
    {
      kind: 'attribute',
      name: 'osType',
    },
    {
      kind: 'attribute',
      name: 'containerPath',
    },
    {
      kind: 'attribute',
      name: 'filterable',
    },
    {
      kind: 'attribute',
      name: 'searchable',
    },
    {
      kind: 'attribute',
      name: 'wordStart',
    },
    {
      kind: 'attribute',
      name: 'highlight',
    },
    {
      kind: 'attribute',
      name: 'scopeKey',
    },
    {
      kind: 'attribute',
      name: 'deprecated',
    },
    {
      kind: 'attribute',
      name: 'options',
    },
    {
      kind: 'attribute',
      name: 'position',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'indexDefinition',
      type: 'index-definition',
      options: {
        async: false,
        inverse: 'dataPoints',
      },
    },
    {
      kind: 'belongsTo',
      name: 'aliasOf',
      type: 'data-point',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default SearchDataPointSchema;
